module.exports = __webpack_public_path__ + "static/img/Andre-Carrillo.9cc61b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Andre-Carrillo.jpg
// module id = zWXc
// module chunks = 0